import { FormattedMessage } from 'react-intl';
import styles from './modal.module.css';

export default function ModalDatiPersonali({ onClose, open }) {
  return (
    <div className={styles.root}>
      <div
        className="modal fade show"
        id="exampleModal"
        tabIndex="-1"
        style={{
          display: open ? 'block' : 'none',
          opacity: open ? 1 : 0,
          background: 'rgba(124, 124, 115, 0.8)',
          transition: 'opacity 3s linear 0s'
        }}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog pmi-modal-dialog" role="document">
          <div className="modal-content pmi-modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                <FormattedMessage defaultMessage="Trattamento Dati Personali" />
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  onClose();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 p-0">
                <div className="row m-0 mb-3 snf-font-12">
                  <p className="mb-0">
                    <FormattedMessage defaultMessage="I trattamenti di dati personali relativi al ricevimento e alla gestione delle segnalazioni sono effettuati da Sistemi Informativi S.r.l., in qualità di titolare del trattamento, nel rispetto dei principi di cui agli artt. 13 e 14 del D. Lgs. n. 24/2023, fornendo idonee informazioni alle persone segnalanti e alle persone coinvolte, nonché adottando misure appropriate a tutela dei diritti e delle libertà degli interessati." />
                  </p>
                  <p className="mb-0">
                    <FormattedMessage
                      defaultMessage="<i><b>Finalità di trattamento:</b></i> Connessa alla gestione della segnalazione e per adempiere agli obblighi previsti dalla legge italiana, dai regolamenti o dalla normativa comunitaria, o per la difesa dei diritti dell'azienda."
                      values={{
                        i: (chunks) => <i>{chunks}</i>,
                        b: (chunks) => <b>{chunks}</b>
                      }}
                    />
                  </p>
                  <p className="mb-0">
                    <FormattedMessage
                      defaultMessage="<i><b>Base Giuridica:</b></i> L'obbligo giuridico derivante dalle previsioni dal D. Lgs. 10 marzo 2023 n. 24, che ha modificato il D. Lgs. n. 231 del 2001, nonché il conseguente diritto di difesa."
                      values={{
                        i: (chunks) => <i>{chunks}</i>,
                        b: (chunks) => <b>{chunks}</b>
                      }}
                    />
                  </p>
                  <p className="mb-0">
                    <FormattedMessage
                      defaultMessage="<i><b>Natura del conferimento dei dati personali e conseguenze dell'eventuale rifiuto:</b></i> Il conferimento dei dati del segnalante è obbligatorio nella segnalazione non anonima e un eventuale rifiuto al conferimento può cambiare natura alla segnalazione e renderla anonima, così da non poter dare riscontro alla richiesta."
                      values={{
                        i: (chunks) => <i>{chunks}</i>,
                        b: (chunks) => <b>{chunks}</b>
                      }}
                    />
                  </p>
                  <p className="mb-0">
                    <FormattedMessage
                      defaultMessage="<i><b>Periodo di conservazione:</b></i> I Dati Personali sono trattati, per la raccolta, nel repository del canale Confidentially Speaking e memorizzati su server del Titolare (sotto il controllo del Gestore delle segnalazioni) ubicati nell'ambito del territorio nazionale. Le segnalazioni, interne ed esterne, e la relativa documentazione sono conservate per il tempo necessario al trattamento della segnalazione stessa e, comunque, per il tempo necessario all'effettuazione delle indagini per la Segnalazione o la difesa dei diritti dell'azienda, nel rispetto di quanto indicato all'art. 14 del D. Lgs. n. 24/2023."
                      values={{
                        i: (chunks) => <i>{chunks}</i>,
                        b: (chunks) => <b>{chunks}</b>
                      }}
                    />
                  </p>
                  <p className="mb-0">
                    <FormattedMessage
                      defaultMessage="<i><b>Comunicazione a Terzi:</b></i> Nella fase di accertamento della fondatezza della segnalazione, laddove si renda necessario per esigenze connesse alle attività istruttorie, i dati personali potranno essere inoltrati ad altre strutture e/o funzioni Sistemi Informativi o del Gruppo IBM con il Suo consenso. Sussistendone gli estremi, i Suoi Dati Personali potranno essere comunicati anche a soggetti terzi, ricompresi nelle seguenti categorie: Consulenti (Organizzazione, Studi Legali, ecc.), Istituzioni e/o Autorità Pubbliche, Autorità Giudiziaria, Organi di Polizia, Agenzie investigative. In ogni caso, i dati personali non saranno oggetto di diffusione."
                      values={{
                        i: (chunks) => <i>{chunks}</i>,
                        b: (chunks) => <b>{chunks}</b>
                      }}
                    />
                  </p>
                  <p>
                    <FormattedMessage
                      defaultMessage="<i><b>Tutela dei propri diritti Privacy:</b></i> Per ulteriori dettagli vedi <policy>(POLICY ON LINE)</policy>. I diritti di cui agli articoli da 15 a 22 del Regolamento (UE) 2016/679 (GDPR) possono essere esercitati nei limiti di quanto previsto dall'art. 13 comma 3 dello stesso D. Lgs. n. 24/2023. L'esercizio dei diritti privacy è possibile attraverso richiesta da indirizzare a: <email>Tutelaprivacy@sistinf.it</email>"
                      values={{
                        i: (chunks) => <i>{chunks}</i>,
                        b: (chunks) => <b>{chunks}</b>,
                        policy: (chunks) => (
                          <a
                            href="/assets/Privacy OnLine Sistemi Informativi ITA-PRI 3.01.pdf"
                            target="_blank"
                          >
                            {chunks}
                          </a>
                        ),
                        email: (chunks) => <a href="mailto:Tutelaprivacy@sistinf.it">{chunks}</a>
                      }}
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
